import { Survey, SurveyForm, SurveyPhase } from '../types'

export const processScreensForCompletedSurvey = (survey: Survey): Survey => {
  const dataFormStringified = survey?.form || null
  const form: SurveyForm | null = dataFormStringified ? JSON.parse(dataFormStringified) : null
  
  if(!form){
    return survey
  }

  form.welcomeScreens = [
    {
      title: 'Completed Survey',
      description: 'This survey had already been completed. Please contact you care team if you would like a new survey',
      nextButtonTitle: 'View',
      id: 'Completed_Survey',
    },
  ]
  form.followUpScreens = [
    {
      title: 'Thank you',
      description: 'This survey had already been previously completed.',
      nextButtonTitle: 'Home',
      id: 'Thank_you_123',
    },
  ]
  return survey
}

export const getFirstSurveyScreens = (survey?: Survey): SurveyPhase => {
  const dataFormStringified = survey?.form || null
  const form: SurveyForm | null = dataFormStringified ? JSON.parse(dataFormStringified) : null
  
  if (!survey) {
    return 'Welcome'
  }
  if (survey.completedOn) {
    return 'Welcome'
  }
  if (form?.welcomeScreens?.length) {
    return 'Welcome'
  }
  return 'Questions'
}
